import { AdControlBannerModel, AdropParamsFactory } from '@/entities/advertisement';
import { cn } from '@/utils/style';
import React, { useEffect } from 'react';

interface AdropBannerProps {
  adData: AdControlBannerModel;
  adropParamsFactory: AdropParamsFactory;
  adControlUpdatedAt?: number;
  className?: string;
  style?: React.CSSProperties;
  borderRadius?: number;
  showAdBadge?: boolean;
  fallback: React.ReactNode;
  onLoad?: () => void;
  onError?: (error: Error) => void;
}

const AdropBanner: React.FC<AdropBannerProps> = (props) => {
  const showAdBadge = props.showAdBadge ?? true;

  useEffect(() => {
    if (props.adData?.isVisible) {
      props.onLoad?.();
    }
  }, [props.adData?.isVisible]);

  // 광고가 없으면 폴백UI 렌더링
  if (!props.adData?.isVisible) {
    return props.fallback;
  }

  const uniqueId = `adrop-banner-${props.adropParamsFactory.getAdPageType()}-${props.adropParamsFactory.getUnitId()}-${props.adControlUpdatedAt}`;

  return (
    <div className={props.className}>
      <div className={'relative bg-white'}>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .${uniqueId} img {
                border-radius: ${props.borderRadius ?? 0}px;
                aspect-ratio: ${props.adropParamsFactory.getAspect()} !important;
              }
            `,
          }}
        />
        <div
          role='img'
          aria-label='광고 배너'
          className={cn('overflow-hidden', uniqueId)}
          dangerouslySetInnerHTML={{
            __html: props.adData.bannerHtml,
          }}
          style={{
            ...props.style,
          }}
        />
        {showAdBadge && (
          <div className='pointer-events-none absolute right-[8px] bottom-[8px] flex h-[18px] w-[28px] items-center justify-center rounded-[5px] bg-dimmed-40'>
            <p className='typography-ui-12m text-white'>AD</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdropBanner;
